// extracted by mini-css-extract-plugin
module.exports = {"addButton":"SchoolsTable_addButton__2qOeW","searchField":"SchoolsTable_searchField__3DBfu"};